import Entrance from './pages/Entrance';

//localstorage uses key value as DOMstring
export const FLAG = {
  RUNNING : '0',
  PAUSED: '1',
  IDLE : '2',
  CREATED: '3',
}

export const KEY = {
  FOLLOW                          : ['follow',                true],
  UNFOLLOW                        : ['unfollow',              false],
  CYCLIC                          : ['cyclic',                false],
  UNFOLLOW_PASSIVE_1ST            : ['passive_1st',           false],
  URL                             : ['URL',                   ''],
  COUNT                           : ['COUNT',                 '85'],
  FOLLOW_CNT                      : ['FOLLOW_CNT',            '85'],
  UNFOLLOW_CNT                    : ['UNFOLLOW_CNT',          '85'],
  FOLLOW_PROS_ONLY                : ['follow_pros_only',      false],
  WHITELIST_MANUAL_FOLLOWINGS     : ['whitelist_manual_followings',      false],
  HH                              : ['hh',                    10],
  MM                              : ['mm',                    0],
  BUSY                            : ['busy',                  false],//when query sent to server to start something or cancel something
  OPTIONS_ARE_CORRECT             : ['options_are_correct',   false],
  OPTIONS_UI_SET_TIME             : ['options_ui_time',       0],
  OPTIONS_DISABLED                : ['options_disabled',      true],
  ACCOUNT_SETS_SERVER_TS          : ['account_sets_server_ts', 0],
  SCHEDULE_ON             : ['schedule_on',           true],
}



export const Globs = {

  getVarsForCurAccount(){
    //createThisSetsIfNull();
    if (this.sets === null || this.sets === undefined){
      var jstr = localStorage.getItem('sets');

      if (jstr === null){
        //this.sets = new Object();
        this.sets = {};
        localStorage.setItem('sets', JSON.stringify(this.sets));
      }else {
        this.sets = JSON.parse(jstr);
      }
    }

    var aid = Entrance.accountId();
    var vars = this.sets[aid];

    if (vars === null || vars === undefined) {
      //vars = new Object();
      vars = {};
      this.sets[aid] = vars;
    }

    return vars;
  },


  get(key){

    var vars = this.getVarsForCurAccount();

    var name = key[0];
    var valByDefault = key[1];

    var item = vars[name];

    if (item===null || item===undefined) {
      item = valByDefault;
    }

    // switch (name) {
    //   case KEY.UNFOLLOW_PASSIVE_1S
    //   default: break;
    // }

    return item;
  },


  set(key, value) {

    var vars = this.getVarsForCurAccount();
    var name = key[0];

    switch (name)
    {

      case KEY.FOLLOW[0]:
      case KEY.UNFOLLOW[0]:
      case KEY.CYCLIC[0]:
      case KEY.UNFOLLOW_PASSIVE_1ST[0]:
      case KEY.FOLLOW_PROS_ONLY[0]:
      case KEY.WHITELIST_MANUAL_FOLLOWINGS[0]:
      case KEY.BUSY[0]:
        if(value === 'true'){
          value = true;
        }else if(value === 'false'){
          value = false;
        }
        break;

      case KEY.URL[0]: break;
      case KEY.COUNT[0]: value = Number(value); break;
      case KEY.FOLLOW_CNT[0]: value = Number(value); break;
      case KEY.UNFOLLOW_CNT[0]: value = Number(value); break;

      default: break;
    }

    vars[name] = value;

    localStorage.setItem('sets', JSON.stringify(this.sets));
  },

  setActivityFlag(flag) {
    localStorage.setItem('activity_flag', flag);
  },

  activityFlag() {

    var item = localStorage.getItem('activity_flag');
    if (item===null)
    {
      this.setActivityFlag(FLAG.IDLE);
      return FLAG.IDLE;
    }

    return item;
  },

  isActivityFlagIs(flag) {
    return (this.activityFlag() === flag);
  },

  activityFlagIsRunning() {
    return (this.activityFlag() === FLAG.RUNNING);
  },

  activityFlagIsPaused() {
    return (this.activityFlag() === FLAG.PAUSED);
  },

  activityFlagIsIdle() {
    return (this.activityFlag() === FLAG.IDLE);
  },

  activityFlagIsBusy() {
    return (this.activityFlag() === FLAG.BUSY);
  },

  activityFlagIsCreated() {
    return (this.activityFlag() === FLAG.CREATED);
  },
}

